import { render, staticRenderFns } from "./WalletsTable.vue?vue&type=template&id=509a8330&"
import script from "./WalletsTable.vue?vue&type=script&lang=js&"
export * from "./WalletsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports